import { render, staticRenderFns } from "./MoneyTextField.vue?vue&type=template&id=58772f90&"
import script from "./MoneyTextField.vue?vue&type=script&lang=js&"
export * from "./MoneyTextField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports